<div class="card shadow border-0 p-3 mt-3">
  <div class="row mx-0 mb-1">
    <span class="checkbox-switch d-block position-relative me-3">
      <input
        type="checkbox"
        [checked]="group.Active"
        (change)="updateNotificationGroup(group.NotificationGroupId, $event.target.checked, group.EntityNotificationGroupId)"
      />
      <div class="slider round"></div>
    </span>
    <span class="font-size-16">{{ group.DisplayText }}</span>
    <span class="font-size-16">{{ group.Description }}</span>
  </div>
</div>
